import React from 'react';

/** Error Boundary global: uma falha de componente não derruba o DNACore inteiro. */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, ref: null };
  }

  static getDerivedStateFromError(error) {
    return { error, ref: `ui-${Date.now().toString(36)}` };
  }

  componentDidCatch(error, info) {
    // registro técnico (console + endpoint opcional) — sem dados sensíveis
    // eslint-disable-next-line no-console
    console.error('[DNACore UI]', this.state.ref, error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-[50vh] flex items-center justify-center p-8" data-testid="ui-error-boundary">
        <div className="max-w-md w-full rounded-2xl border border-rose-200 bg-white shadow p-6 text-center">
          <div className="text-lg font-semibold text-slate-900">Não foi possível exibir esta tela.</div>
          <p className="text-sm text-slate-600 mt-2">Um erro inesperado ocorreu neste componente. O restante do sistema continua funcionando.</p>
          <p className="text-xs text-slate-500 mt-3">Código de referência: <code data-testid="ui-error-ref">{this.state.ref}</code></p>
          <div className="mt-4 flex gap-2 justify-center">
            <button className="px-4 py-2 rounded-lg bg-violet-700 text-white text-sm" data-testid="ui-error-retry"
              onClick={() => this.setState({ error: null, ref: null })}>Tentar novamente</button>
            <button className="px-4 py-2 rounded-lg border text-sm" onClick={() => { window.location.href = '/'; }}>Ir para o início</button>
          </div>
        </div>
      </div>
    );
  }
}
